export default __webpack_public_path__ + "static/media/contact.326a5b5a.jpg";